// **AUTH** //
export const AUTH_REGISTER_WITH_COGNITO = [
    '/auth/register-with-cognito',
    'POST',
];

// **USERS** //
export const USERS_DATA = [
    '/users',
    'GET',
]

export const CREATE_USER = [
    '/users',
    'POST'
]

export const GET_MONGO_USER_ID = [
    "/users/by-cognito/:cognitoId",
    "GET",
]

export const USER_DETAIL = [
    '/users/:userId',
    'GET'
]

export const UPDATE_USER = [
    '/users/:userId',
    'PATCH'
]

export const TEAM_MEMBERS_LIST = [
    '/users/team-members',
    'GET',
]

// **COMPANIES** //
export const COMPANIES_DATA = [
    '/companies',
    'GET',
]

export const CREATE_COMPANY = [
    '/companies',
    'POST'
]

export const COMPANY_DETAIL = [
    '/companies/:companyId',
    'GET'
]

export const COMPANY_DOMAIN = [
    '/companies/domain/:domain',
    'GET',
]

export const COMPANY_DETAIL_OF_USER = [
    '/companies/get-info',
    'GET'
]

export const UPDATE_COMPANY_DETAIL = [
    '/companies/update-info',
    'PATCH'
]

export const UPDATE_COMPANY = [
    '/companies/:companyId',
    'PATCH'
]

export const ADMIN_DASHBOARD_STATS = [
    '/companies/dashboard-stats',
    'GET'
]

// **INVITE** //
export const INVITES_DATA = [
    '/invites',
    'GET',
]

export const CREATE_INVITE = [
    '/invites',
    'POST'
]

export const INVITE_DETAIL = [
    '/invites/:inviteId',
    'GET'
]

export const UPDATE_INVITE = [
    '/invites/:inviteId',
    'PATCH'
]

export const COMPANY_INVITE_LIST = [
    '/invites/company:companyId',
    'GET',
]

export const SEND_INVITE = [
    '/invites/send',
    'POST',
]

export const UPLOAD_COMPANY_LOGO = [
    '/companies/upload-company-logo',
    'POST',
]

export const RAISE_CONCERN = [
    '/companies/:companyId/raise-concern',
    'POST'
]

// **Requirements** //

export const REQUIREMENTS_DATA = [
    '/requirements',
    'GET',
]

export const CREATE_REQUIREMENT = [
    '/requirements',
    'POST'
]

export const REQUIREMENT_DETAIL = [
    '/requirements/:requirementId',
    'GET'
]

export const UPDATE_REQUIREMENT = [
    '/requirements/:requirementId',
    'PATCH'
]

export const REQUIREMENTS_COUNT_BY_STATUS = [
    '/requirements/count',
    'GET',
]

export const BUYER_DASHBOARD_STATS = [
    '/requirements/dashboard-stats',
    'GET',
]

export const BUYER_MILESTONE_STATS = [
    '/requirements/milestone-stats',
    'GET',
]

// **Seller Requirements** //
export const SELLER_REQUIREMENTS_DATA = [
    '/seller-requirements',
    'GET',
]

export const CREATE_SELLER_REQUIREMENT = [
    '/seller-requirements',
    'POST'
]

export const SELLER_REQUIREMENT_DETAIL = [
    '/seller-requirements/:requirementId',
    'GET'
]

export const UPDATE_SELLER_REQUIREMENT = [
    '/seller-requirements/:requirementId',
    'PATCH'
]

export const UPDATE_SELLER_BOOKMARK = [
    '/seller-requirements/bookmark/:requirementId',
    'PATCH'
]

export const SELLER_REQUIREMENTS_COUNT_BY_STATUS = [
    '/seller-requirements/count',
    'GET',
]

export const SELLER_REQUIREMENTS_BY_BUYER_RFQ_ID = [
    '/seller-requirements/buyer/rfq-id/:requirementId',
    'GET'
]

// **Group Chats** //
export const GROUP_CHAT_LIST = [
    '/group-chats',
    'GET',
];

export const PROJECT_MANAGER_DASHBOARD_STATS = [
    '/group-chats/pm-dashboard-stats',
    'GET',
];

export const GROUP_CHAT_DETAIL = [
    '/group-chats/:groupId',
    'GET',
];

export const CREATE_GROUP_CHAT = [
    '/group-chats',
    'POST',
];

export const SEND_GROUP_MESSAGE = [
    '/group-chats/messages',
    'POST',
];

export const GET_GROUP_MESSAGES = [
    '/group-chats/:groupId/messages',
    'GET',
];

export const GROUP_CHAT_UPLOAD_URL = [
    '/group-chats/upload-url',
    'POST',
];

export const ADD_GROUP_MEMBER = [
    '/group-chats/:groupId/members',
    'POST',
];

export const REMOVE_GROUP_MEMBER = [
    '/group-chats/:groupId/members',
    'DELETE',
];

export const GET_GROUP_FILES = [
    '/group-chats/:groupId/files',
    'GET',
];

export const UPDATE_GROUP_STATUS = [
    '/group-chats/:groupId/status',
    'PATCH',
];

export const SELLER_BUDGET_DISTRIBUTION = [
    '/group-chats/budget-distribution',
    'GET',
];

export const SELLER_UPCOMING_MILESTONES = [
    '/group-chats/upcoming-milestones',
    'GET',
];

// **Milestone** //

export const UPDATE_MILESTONE = [
    '/group-chats/:groupId/milestone-status/:milestoneId',
    'PATCH'
]

// **Feedback** //
export const FEEDBACK_DATA = [
    '/feedback',
    'GET',
]

export const CREATE_FEEDBACK = [
    '/feedback',
    'POST'
]

// **Notifications** //
export const GET_NOTIFICATIONS = [
    '/notifications',
    'GET',
]

export const GET_UNREAD_COUNT = [
    '/notifications/unread-count',
    'GET',
]

export const MARK_NOTIFICATION_READ = [
    '/notifications/:id/read',
    'PATCH',
]

export const MARK_ALL_READ = [
    '/notifications/read-all',
    'PATCH',
]

export const CREATE_BROADCAST = [
    '/notifications/broadcast',
    'POST',
]

export const GET_BROADCASTS = [
    '/notifications/broadcasts',
    'GET',
]
